// InStock Notify App - Custom Popup UI Integration
// This file integrates with the InStock Notify Shopify app to:
// 1. Make green button trigger InStock Notify app popup
// 2. Apply custom styling to the app's popup modal
// 3. Add product titles to the popup
// 4. Validate Australian phone numbers
// 5. Provide a consistent UI experience matching the site design

// Success Popup Functions
window.openInstockSuccessPopup = function() {
  const successPopup = document.getElementById('instock-success-popup');
  if (successPopup) {
    successPopup.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
};

window.closeInstockSuccessPopup = function() {
  const successPopup = document.getElementById('instock-success-popup');
  if (successPopup) {
    successPopup.style.display = 'none';
    document.body.style.overflow = '';
  }
};

// Initialize InStock Notify integration when page loads
document.addEventListener('DOMContentLoaded', function() {
  // Find all green "Notify Me" buttons and add click handlers
  const notifyButtons = document.querySelectorAll('.restock-alerts-trigger, .notify-button');


  notifyButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      const productTitle = this.getAttribute('data-product-title') || this.textContent;
      const productId = this.getAttribute('data-product-id');
      const variantId = this.getAttribute('data-variant-id');


      // Try to trigger InStock Notify app
      triggerInstockNotify(productTitle, productId, variantId);
    });
  });

  // Monitor for InStock Notify form submission
  monitorInstockFormSubmission();

  // Start monitoring for InStock Notify app popup forms
  monitorForPluginForms();

  // Monitor when any buttons are clicked (in case popup opens)
  document.addEventListener('click', function(e) {
    const target = e.target;

    // Check if a notify/restock button was clicked (including InStock Notify app buttons)
    if (target.matches(
      'button[class*="notify"], button[id*="notify"], ' +
      'button[class*="restock"], button[id*="restock"], ' +
      '.bis-button, .back-in-stock-button, ' +
      '.restock-alerts-button, .instock-notify-button, ' +
      '[data-notify-button], [data-product-notify], ' +
      '[data-restock-button]'
    )) {
      // Start monitoring for the popup form
      setTimeout(() => {
        monitorForPluginForms();
      }, 100);
    }
  });
});

function triggerInstockNotify(productTitle, productId, variantId) {

  // Method 1: Find the specific InStock Notify button by ID
  const instockButton = document.getElementById('openInStockNotifyModal');

  if (instockButton) {
    instockButton.click();

    // Add custom product title div after plugin popup opens
    setTimeout(() => {
      addCustomProductTitle(productTitle);
    }, 500);

    return;
  } else {
  }

  // Method 2: Try alternative selectors for InStock Notify button
  const alternativeButtons = document.querySelectorAll(
    '.floating-button, ' +
    'button[id*="InStockNotify"], ' +
    'button[class*="floating-button"]'
  );


  if (alternativeButtons.length > 0) {
    for (let btn of alternativeButtons) {
      if (!btn.classList.contains('restock-alerts-trigger') &&
          !btn.classList.contains('product-form__submit')) {
        btn.click();

        setTimeout(() => {
          addCustomProductTitle(productTitle);
        }, 500);

        return;
      }
    }
  } else {
  }

  // Method 2: Check for InStock Notify app window objects
  if (typeof window.RestockAlerts !== 'undefined' && typeof window.RestockAlerts.open === 'function') {
    window.RestockAlerts.open();
    setTimeout(() => {
      addCustomProductTitle(productTitle);
    }, 500);
    return;
  }

  if (typeof window.InstockNotify !== 'undefined' && typeof window.InstockNotify.open === 'function') {
    window.InstockNotify.open();
    setTimeout(() => {
      addCustomProductTitle(productTitle);
    }, 500);
    return;
  }

  // Method 3: Try to find and open the popup directly using RestockAlerts API with product info
  if (typeof window.RestockAlerts !== 'undefined') {

    // Try common methods for opening with product/variant ID
    if (typeof window.RestockAlerts.openModal === 'function') {
      window.RestockAlerts.openModal(variantId);
      setTimeout(() => addCustomProductTitle(productTitle), 500);
      return;
    }

    if (typeof window.RestockAlerts.showForm === 'function') {
      window.RestockAlerts.showForm(variantId);
      setTimeout(() => addCustomProductTitle(productTitle), 500);
      return;
    }

    if (typeof window.RestockAlerts.trigger === 'function') {
      window.RestockAlerts.trigger(variantId);
      setTimeout(() => addCustomProductTitle(productTitle), 500);
      return;
    }
  }

  // Method 4: Dispatch custom events that the InStock Notify app might listen to
  const restockEvent = new CustomEvent('openRestockAlerts', {
    detail: {
      productTitle: productTitle,
      productId: productId,
      variantId: variantId
    }
  });
  document.dispatchEvent(restockEvent);

  // Add product title after a delay
  setTimeout(() => {
    addCustomProductTitle(productTitle);
  }, 500);

}



// Function to set country to Australia and disable selector
function setCountryToAustralia() {
  // Try multiple selectors to find the country selector
  const selectors = [
    '#inStockNotifyForm #countryCode',
    '#inStockNotifyForm select[name*="country"]',
    '#inStockNotifyForm .restock-alerts-country-select',
    'select.restock-alerts-country-select',
    '#countryCode'
  ];

  let countrySelect = null;
  for (let selector of selectors) {
    countrySelect = document.querySelector(selector);
    if (countrySelect) {
      break;
    }
  }

  if (countrySelect) {
    // Set to Australia - try different possible values
    if (countrySelect.querySelector('option[value="AU"]')) {
      countrySelect.value = 'AU';
    } else if (countrySelect.querySelector('option[value="Australia"]')) {
      countrySelect.value = 'Australia';
    } else if (countrySelect.querySelector('option[value="australia"]')) {
      countrySelect.value = 'australia';
    } else if (countrySelect.querySelector('option[value="+61"]')) {
      countrySelect.value = '+61';
    }

    // Disable the selector so it can't be changed
    countrySelect.disabled = true;

  } else {
  }
}

// Function to add custom close button to the top right
function addCustomCloseButton() {
  // Find the modal or form container
  const modal = document.getElementById('inStockNotifyModal') ||
                 document.querySelector('.modalBoxStyle') ||
                 document.querySelector('.restock-alerts-overlay');

  if (!modal) {
    return;
  }

  // Check if close button already exists
  if (modal.querySelector('.custom-close-icon')) {
    return;
  }

  // Create close button
  const closeBtn = document.createElement('button');
  closeBtn.className = 'custom-close-icon closeIconStyle';
  closeBtn.innerHTML = '&times;';
  closeBtn.setAttribute('type', 'button');
  closeBtn.setAttribute('aria-label', 'Close');

  // Add click handler
  closeBtn.addEventListener('click', function() {
    const closeModalBtn = document.getElementById('closeInStockNotifyModal');
    if (closeModalBtn) {
      closeModalBtn.click();
    } else {
      // Fallback: hide the modal directly
      const overlay = document.querySelector('.restock-alerts-overlay, .restock-alerts-modal-overlay');
      if (overlay) {
        overlay.style.display = 'none';
      }
      if (modal) {
        modal.style.display = 'none';
      }
      document.body.style.overflow = '';
    }
  });

  // Find the best container to append to
  const modalContent = modal.querySelector('.modal-content') ||
                       modal.querySelector('.modalBoxStyle') ||
                       modal;

  // Make sure the container has relative positioning
  if (modalContent) {
    const computedStyle = window.getComputedStyle(modalContent);
    if (computedStyle.position === 'static') {
      modalContent.style.position = 'relative';
    }
    modalContent.appendChild(closeBtn);
  }
}

// Function to validate email format
function isValidEmail(email) {
  if (!email || email.trim() === '') {
    return false;
  }
  // Basic email validation regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
}

// Function to check if form is valid and update button state
function validateFormAndUpdateButton(form) {
  if (!form) return;

  const emailInput = form.querySelector('input[type="email"], input#email, input[name="email"]');
  const phoneInput = form.querySelector('input[type="tel"], input#phone, input[name="phone"], input[name*="sms"]');
  const submitButton = form.querySelector('button[type="submit"], .submit-button, .restock-alerts-submit-button') ||
                       document.querySelector('#inStockNotifyForm button[type="submit"]') ||
                       document.querySelector('#inStockNotifyForm .submit-button');

  if (!submitButton) {
    return;
  }

  const emailValue = emailInput ? emailInput.value.trim() : '';
  const phoneValue = phoneInput ? phoneInput.value.trim() : '';

  const isEmailValid = isValidEmail(emailValue);
  const isPhoneValid = phoneValue && isValidPhoneNumber(phoneValue);


  // Enable button if either email OR phone is valid
  if (isEmailValid || isPhoneValid) {
    submitButton.disabled = false;
    submitButton.style.opacity = '1';
    submitButton.style.cursor = 'pointer';
    submitButton.style.pointerEvents = 'auto';
  } else {
    submitButton.disabled = true;
    submitButton.style.opacity = '0.5';
    submitButton.style.cursor = 'not-allowed';
    submitButton.style.pointerEvents = 'none';
  }
}

// Function to set up phone validation and button control
function setupPhoneValidation(form) {
  if (!form) return;


  // Find inputs
  const emailInput = form.querySelector('input[type="email"], input#email, input[name="email"]');
  const phoneInput = form.querySelector('input[type="tel"], input#phone, input[name="phone"], input[name*="sms"]');
  const submitButton = form.querySelector('button[type="submit"], .submit-button, .restock-alerts-submit-button') ||
                       document.querySelector('#inStockNotifyForm button[type="submit"]') ||
                       document.querySelector('#inStockNotifyForm .submit-button');

  if (!submitButton) {
    return;
  }


  // Set placeholders
  if (phoneInput) {
    phoneInput.placeholder = 'Contact No.';
  }

  // Disable button initially
  submitButton.disabled = true;
  submitButton.style.opacity = '0.5';
  submitButton.style.cursor = 'not-allowed';
  submitButton.style.pointerEvents = 'none';

  // Add event listeners to email input
  if (emailInput) {
    emailInput.addEventListener('input', function() {
      const emailValue = this.value.trim();

      // Update border color
      if (emailValue && isValidEmail(emailValue)) {
        this.style.borderColor = '#4CAF50'; // Green for valid
      } else if (emailValue) {
        this.style.borderColor = '#ffa500'; // Orange for invalid
      } else {
        this.style.borderColor = '';
      }

      // Validate form
      validateFormAndUpdateButton(form);
    });
  }

  // Add event listeners to phone input
  if (phoneInput) {
    phoneInput.addEventListener('input', function() {
      const phoneValue = this.value.trim();

      // Clear previous errors
      const errorMsg = form.querySelector('.phone-validation-error');
      if (errorMsg) {
        errorMsg.style.display = 'none';
      }

      // Update border color
      if (phoneValue && isValidPhoneNumber(phoneValue)) {
        this.style.borderColor = '#4CAF50'; // Green for valid
      } else if (phoneValue) {
        this.style.borderColor = '#ffa500'; // Orange for invalid
      } else {
        this.style.borderColor = '';
      }

      // Validate form
      validateFormAndUpdateButton(form);
    });
  }

}

// Function to add placeholders to form inputs
function addPlaceholdersToForm(form) {
  if (!form) return;

  // Add placeholder to email input
  const emailInput = form.querySelector('input[type="email"], input#email, input[name="email"]');
  if (emailInput && !emailInput.placeholder) {
    emailInput.placeholder = 'Email';
  }

  // Add placeholder to phone input
  const phoneInput = form.querySelector('input[type="tel"], input#phone, input[name="phone"]');
  if (phoneInput && !phoneInput.placeholder) {
    phoneInput.placeholder = 'Contact No.';
  }

  // Set up phone validation
  setupPhoneValidation(form);
}

// Phone number validation function
function isValidPhoneNumber(phone) {
  if (!phone || phone.trim() === '') {
    return true; // Allow empty phone numbers (optional field)
  }

  // Remove all non-digit characters for validation
  const cleanPhone = phone.replace(/\D/g, '');

  // Australian mobile number validation - exactly 9 digits
  // Pattern: 4XXXXXXXX (9 digits starting with 4)
  if (/^4[0-9]{8}$/.test(cleanPhone)) {
    return true;
  }

  // Everything else is rejected
  return false;
}

// Function to validate and intercept plugin form submissions
function interceptPluginFormSubmission() {
  // Look for the restock alerts form that the plugin creates
  const restockForm = document.querySelector('.restock-alerts-form');

  if (restockForm) {
    // Set Australia as default country and disable other countries
    const countrySelect = restockForm.querySelector('.restock-alerts-country-select');
    if (countrySelect) {
      // Set Australia (AU) as selected
      countrySelect.value = 'AU';
      // Disable the dropdown so users can't change it
      countrySelect.disabled = true;
      // Add a visual style to indicate it's disabled
      countrySelect.style.opacity = '0.6';
      countrySelect.style.cursor = 'not-allowed';
    }

    // Find the SMS input field
    const smsInput = restockForm.querySelector('.restock-alerts-sms-input, input[name*="sms"], input[name*="phone"], input[type="tel"]');

    if (smsInput) {
      // Update placeholder to show Australian format (9 digits)
      smsInput.placeholder = 'e.g., 412 345 678';

      // Disable submit button by default
      const submitButton = document.querySelector('.restock-alerts-submit-button, #inStockNotifyForm .submit-button, .submit-button');
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.style.opacity = '0.5';
        submitButton.style.cursor = 'not-allowed';
        submitButton.style.pointerEvents = 'none';
      }

      // Add validation on form submission
      const form = restockForm.closest('form') || restockForm;
      
      form.addEventListener('submit', function(e) {
        const phoneValue = smsInput.value.trim();
        
        if (phoneValue && !isValidPhoneNumber(phoneValue)) {
          e.preventDefault();
          e.stopPropagation();
          
          // Show validation error below the input field
          let errorMsg = form.querySelector('.phone-validation-error');
          if (!errorMsg) {
            errorMsg = document.createElement('div');
            errorMsg.className = 'phone-validation-error';
            errorMsg.style.color = 'red';
            errorMsg.style.fontSize = '14px';
            errorMsg.style.marginTop = '5px';
            errorMsg.style.marginBottom = '10px';

            // Insert after the input container
            const inputContainer = smsInput.closest('.restock-alerts-sms-input-container, .restock-alerts-sms-channel-form');
            if (inputContainer) {
              inputContainer.parentNode.insertBefore(errorMsg, inputContainer.nextSibling);
            } else {
              smsInput.parentNode.insertBefore(errorMsg, smsInput.nextSibling);
            }
          }

          errorMsg.textContent = 'Please enter a valid Australian mobile number (9 digits starting with 4, e.g., 412345678)';
          errorMsg.style.display = 'block';
          
          // Highlight the input field
          smsInput.style.borderColor = 'red';
          smsInput.focus();
          
          return false;
        } else {
          // Remove any existing error messages
          const errorMsg = form.querySelector('.phone-validation-error');
          if (errorMsg) {
            errorMsg.style.display = 'none';
          }
          smsInput.style.borderColor = '';
        }
      });
      
      // Clear error and validate in real-time when user starts typing
      smsInput.addEventListener('input', function() {
        const errorMsg = restockForm.querySelector('.phone-validation-error');
        if (errorMsg) {
          errorMsg.style.display = 'none';
        }
        this.style.borderColor = '';

        // Real-time validation feedback
        const phoneValue = this.value.trim();
        const submitButton = document.querySelector('.restock-alerts-submit-button, #inStockNotifyForm .submit-button, .submit-button');

        if (phoneValue && isValidPhoneNumber(phoneValue)) {
          // Valid phone number - enable submit button
          this.style.borderColor = '#4CAF50'; // Green border for valid
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.classList.remove('disabled');
            submitButton.removeAttribute('disabled');
            submitButton.style.opacity = '1';
            submitButton.style.cursor = 'pointer';
            submitButton.style.pointerEvents = 'auto';
          }
        } else {
          // Invalid or empty phone number - disable submit button
          if (phoneValue) {
            this.style.borderColor = '#ffa500'; // Orange border for warning
          }
          if (submitButton) {
            submitButton.disabled = true;
            submitButton.classList.add('disabled');
            submitButton.setAttribute('disabled', 'disabled');
            submitButton.style.opacity = '0.5';
            submitButton.style.cursor = 'not-allowed';
            submitButton.style.pointerEvents = 'none';
          }
        }
      });

      // Also validate on blur (when user leaves the field)
      smsInput.addEventListener('blur', function() {
        const phoneValue = this.value.trim();
        const submitButton = document.querySelector('.restock-alerts-submit-button, #inStockNotifyForm .submit-button, .submit-button');

        if (phoneValue && !isValidPhoneNumber(phoneValue)) {
          let errorMsg = restockForm.querySelector('.phone-validation-error');
          if (!errorMsg) {
            errorMsg = document.createElement('div');
            errorMsg.className = 'phone-validation-error';
            errorMsg.style.color = 'red';
            errorMsg.style.fontSize = '14px';
            errorMsg.style.marginTop = '5px';
            errorMsg.style.marginBottom = '10px';

            // Insert after the input container
            const inputContainer = this.closest('.restock-alerts-sms-input-container, .restock-alerts-sms-channel-form');
            if (inputContainer) {
              inputContainer.parentNode.insertBefore(errorMsg, inputContainer.nextSibling);
            } else {
              this.parentNode.insertBefore(errorMsg, this.nextSibling);
            }
          }
          errorMsg.textContent = 'Please enter a valid Australian mobile number (9 digits starting with 4, e.g., 412345678)';
          errorMsg.style.display = 'block';
          this.style.borderColor = 'red';

          // Disable submit button
          if (submitButton) {
            submitButton.disabled = true;
            submitButton.classList.add('disabled');
            submitButton.setAttribute('disabled', 'disabled');
            submitButton.style.opacity = '0.5';
            submitButton.style.cursor = 'not-allowed';
            submitButton.style.pointerEvents = 'none';
          }
        } else if (phoneValue && isValidPhoneNumber(phoneValue)) {
          // Valid phone number - enable submit button
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.classList.remove('disabled');
            submitButton.removeAttribute('disabled');
            submitButton.style.opacity = '1';
            submitButton.style.cursor = 'pointer';
            submitButton.style.pointerEvents = 'auto';
          }
        } else {
          // Empty field - keep button disabled
          if (submitButton) {
            submitButton.disabled = true;
            submitButton.style.opacity = '0.5';
            submitButton.style.cursor = 'not-allowed';
            submitButton.style.pointerEvents = 'none';
          }
        }
      });
    }
  }
}

// Function to add custom product title div to plugin popup
function addCustomProductTitle(productTitle) {

  // Look for the InStock Notify form by ID
  const instockForm = document.getElementById('inStockNotifyForm');

  if (instockForm) {
    const existingTitle = instockForm.querySelector('.custom-product-title');

    if (!existingTitle) {

      // Create the custom product title div
      const customTitleDiv = document.createElement('div');
      customTitleDiv.className = 'custom-product-title';
      customTitleDiv.textContent = productTitle;

      // Create the custom subtitle div
      const customSubtitleDiv = document.createElement('div');
      customSubtitleDiv.className = 'custom-product-subtitle';
      customSubtitleDiv.textContent = 'Enter your contact details to get an email or text message when this plant is available again';

      // Insert as the first child of the form
      instockForm.insertBefore(customTitleDiv, instockForm.firstChild);

      // Insert subtitle after title
      instockForm.insertBefore(customSubtitleDiv, customTitleDiv.nextSibling);


      // Add custom close button if it doesn't exist
      addCustomCloseButton();

      // Set country to Australia
      setCountryToAustralia();

      // Add placeholders to input fields
      addPlaceholdersToForm(instockForm);

      // Set up phone validation for this form
      interceptPluginFormSubmission();

      return;
    } else {
      const existingSubtitle = instockForm.querySelector('.custom-product-subtitle');

      if (!existingSubtitle) {

        // Create the custom subtitle div
        const customSubtitleDiv = document.createElement('div');
        customSubtitleDiv.className = 'custom-product-subtitle';
        customSubtitleDiv.textContent = 'Enter your contact details to get an email or text message when this plant is available again';

        // Insert subtitle after existing title
        instockForm.insertBefore(customSubtitleDiv, existingTitle.nextSibling);

      }

      // Add custom close button if it doesn't exist
      addCustomCloseButton();

      // Set country to Australia
      setCountryToAustralia();

      // Always add placeholders
      addPlaceholdersToForm(instockForm);

      return;
    }
  } else {
  }

  // Fallback: Look for restock-alerts-form (other InStock Notify app versions)
  const restockForm = document.querySelector('.restock-alerts-form');
  if (restockForm && !restockForm.querySelector('.custom-product-title')) {
    const customTitleDiv = document.createElement('div');
    customTitleDiv.className = 'custom-product-title';
    customTitleDiv.textContent = productTitle;

    const customSubtitleDiv = document.createElement('div');
    customSubtitleDiv.className = 'custom-product-subtitle';
    customSubtitleDiv.textContent = 'Enter your contact details to get an email or text message when this plant is available again';

    restockForm.insertBefore(customTitleDiv, restockForm.firstChild);
    restockForm.insertBefore(customSubtitleDiv, customTitleDiv.nextSibling);

    interceptPluginFormSubmission();
    return;
  }
  
  // Fallback: Look for other specific popup form containers (not buttons)
  const formContainers = document.querySelectorAll(
    '.notify-form:not(button), .bis-form:not(button), [class*="popup"] form, [class*="modal"] form'
  );
  
  formContainers.forEach(container => {
    // Only target form containers that are visible and not buttons
    if (container.tagName !== 'BUTTON' && 
        container.offsetParent !== null && 
        !container.querySelector('.custom-product-title')) {
      
      const customTitleDiv = document.createElement('div');
      customTitleDiv.className = 'custom-product-title';
      customTitleDiv.textContent = productTitle;
      
      container.insertBefore(customTitleDiv, container.firstChild);
      
      // Also set up phone validation for this form
      interceptPluginFormSubmission();
    }
  });
}

// Monitor for plugin popup forms and set up validation
function monitorForPluginForms() {
  // Check for forms every 500ms when a popup might be open
  const checkInterval = setInterval(() => {
    const restockForm = document.querySelector('.restock-alerts-form');
    const smsInput = document.querySelector('.restock-alerts-sms-input, input[name*="sms"], input[name*="phone"], input[type="tel"]');
    
    if (restockForm && smsInput && !smsInput.hasAttribute('data-validation-setup')) {
      // Mark as processed to avoid duplicate setup
      smsInput.setAttribute('data-validation-setup', 'true');
      
      // Set up validation
      interceptPluginFormSubmission();
      
      // Clear the interval once we've found and set up the form
      clearInterval(checkInterval);
    }
  }, 500);
  
  // Stop checking after 10 seconds to avoid infinite checking
  setTimeout(() => {
    clearInterval(checkInterval);
  }, 10000);
}

// Monitor InStock Notify form submission to show success popup
function monitorInstockFormSubmission() {
  const checkInterval = setInterval(() => {
    const form = document.getElementById('inStockNotifyForm');
    if (form && !form.hasAttribute('data-success-listener')) {
      form.setAttribute('data-success-listener', 'true');

      form.addEventListener('submit', function(e) {

        // Wait for the InStock Notify app to process the submission
        setTimeout(() => {
          // Close the InStock Notify modal
          const modal = document.getElementById('inStockNotifyModal');
          const closeBtn = document.getElementById('closeInStockNotifyModal');

          if (closeBtn) {
            closeBtn.click();
          } else if (modal) {
            modal.style.display = 'none';
          }

          // Show our custom success popup
          setTimeout(() => {
            window.openInstockSuccessPopup();
          }, 300);
        }, 1000);
      });
    }
  }, 500);

  setTimeout(() => clearInterval(checkInterval), 10000);
}

